import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero, CTABand } from "../components/Shared";
import { SERVICES } from "../data/services";
import { ArrowRight } from "lucide-react";

const BASE = "https://carefirstoh.com";

const Services = () => (
  <div>
    <Seo title="Home Health Services in Columbus, OH | CareFirst Home Health" description="Explore CareFirst home health services in Columbus, Ohio: skilled nursing, home health aide, personal care, respite, medication management, companion care and more." canonical={BASE + "/services"} />
    <PageHero title="Our Home Health Services" subtitle="Skilled and non-skilled care tailored to each patient and delivered in the comfort of home." crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]} />

    <section className="bg-white py-20">
      <div className="max-w-[1240px] mx-auto px-4">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {SERVICES.map((s) => (
            <div key={s.slug} className="group rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col">
              <div className="h-44 overflow-hidden"><img src={s.image} alt={`${s.name} services in Columbus, Ohio`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
              <div className="p-6 flex flex-col flex-1">
                <h2 className="font-display text-[#16357a] text-[21px] font-semibold mb-2">{s.name}</h2>
                <p className="text-[#666] text-[14px] leading-relaxed mb-4 flex-1">{s.short}</p>
                <Link to={`/services/${s.slug}`} className="inline-flex items-center gap-1 text-[#4ca82f] font-semibold text-[14px] hover:gap-2 transition-all">Learn more <ArrowRight size={15} /></Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <CTABand />
  </div>
);

export default Services;
